import React from "react";
import { Alert, AutoComplete, Form, Input, Modal } from "antd";
import styles from "./directory.module.css";

const BulkEditForm = ({ count, companies, saving, error, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const company = Form.useWatch("inviteeCompany", form);
  const address = Form.useWatch("inviteeCompanyAddress", form);
  const hasChanges = Boolean(company?.trim() || address?.trim());

  return (
    <Modal
      open
      title="Bulk Edit"
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText="Save Changes"
      confirmLoading={saving}
      okButtonProps={{ disabled: !hasChanges }}
      cancelButtonProps={{ disabled: saving }}
      closable={!saving}
      maskClosable={!saving}
      keyboard={!saving}
      destroyOnHidden
    >
      <p className={`${styles.paragraph} ${styles.secondary}`}>
        Update company details for {count} selected {count === 1 ? "contact" : "contacts"}.
        {" "}Leave a field blank to keep its current value.
      </p>
      <Form form={form} layout="vertical" onFinish={onSubmit} disabled={saving}>
        {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 20 }} />}
        <Form.Item name="inviteeCompany" label="Company Name">
          <AutoComplete
            options={companies}
            filterOption={(input, option) => option.value.toLowerCase().includes(input.toLowerCase())}
            placeholder="Keep current company"
          />
        </Form.Item>
        <Form.Item name="inviteeCompanyAddress" label="Company Address">
          <Input placeholder="Keep current address" autoComplete="street-address" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BulkEditForm;
